// Função para calcular a diferença de dias entre a data atual e a data fornecida
const calcDiasParaVcto = (data) => {
    if (!data) return null;
    
    // Converte a string da data fornecida (formato yyyy-mm-dd) para um objeto Date
    const dataDestino = new Date(data);
    
    // Verifica se a data fornecida é válida
    if (isNaN(dataDestino.getTime())) {
        return "Data inválida.";
    }

    // Obter a data atual e normalizar horas para evitar problemas de arredondamento
    const dataAtual = new Date();
    dataAtual.setHours(0, 0, 0, 0); // Zera as horas para considerar apenas o dia

    // Calcular a diferença em milissegundos
    const diferencaEmMilissegundos = dataDestino - dataAtual;

    // Converter a diferença para dias inteiros e somar 1 para incluir o dia atual no cálculo
    const diferencaEmDias = Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));

    return diferencaEmDias; // Pode ser positivo, negativo ou zero
};


export default  calcDiasParaVcto;
